<template>
  <v-card outlined class="billing-card pa-6">
    <div class="d-flex justify-space-between align-center">
      <h1 class="text-overline font-weight-bold grey--text tracking-wide">{{ label }}</h1>
      <v-avatar :color="avatarColor" size="36" class="elevation-1">
        <v-icon dark>{{ icon }}</v-icon>
      </v-avatar>
    </div>
    <div class="mt-4">
      <h2 class="font-weight-black text-h3 font-family-monospace" :class="valueClass">
        R$ {{ formattedValue }}
      </h2>
      <div class="mt-3">
        <slot name="footer">
          <div v-if="note" class="d-flex align-center">
            <v-icon small :color="noteIconColor" class="mr-1">{{ noteIcon }}</v-icon>
            <span class="subtitle-2 grey--text">{{ note }}</span>
          </div>
        </slot>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatBRLPretty } from "@/utils";

export default {
  name: "BillingKpiCard",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    icon: {
      type: String,
      default: "mdi-calendar",
    },
    avatarColor: {
      type: String,
      default: "primary",
    },
    valueClass: {
      type: String,
      default: "",
    },
    note: {
      type: String,
      default: "",
    },
    noteIcon: {
      type: String,
      default: "mdi-information-outline",
    },
    noteIconColor: {
      type: String,
      default: "grey",
    },
  },
  computed: {
    formattedValue() {
      const n = Number(this.value);
      if (this.value === undefined || this.value === null || !Number.isFinite(n)) return "0,00";
      return formatBRLPretty(n);
    },
  },
};
</script>

<style scoped>
.billing-card {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.billing-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.tracking-wide {
  letter-spacing: 1.5px !important;
}
</style>
